import { Injectable } from '@angular/core';


@Injectable()

export class OrdenacaoPorCheckedService {
    static ordenarPorChecked(listaDeObjetos) {

        const listaOrdenada = [...listaDeObjetos];

        listaOrdenada.sort(function (a, b) {
            if (a.checked && !b.checked) {
                return -1;
            } else if (!a.checked && b.checked) {
                return 1;
            } else {
                return 0;
            }
        });

        return listaOrdenada;
    }
}

const listaOriginal = [
    { nome: 'Item 1', checked: true },
    { nome: 'Item 2', checked: false },
    { nome: 'Item 3', checked: true },
];

const listaOrdenada = OrdenacaoPorCheckedService.ordenarPorChecked(listaOriginal);


// WEBPACK FOOTER //
// ./src/app/services/ordena-objetos-por-checked-true.service.ts